import type { Locale } from '../i18n';

/**
 * ⚠️ **A calendar date as month and day, nothing else** — *10.25* in Hungarian, *10/25* in
 * English. 3 Nov 2026, for the leave bands, which printed the wire string's tail (*10-25*).
 *
 * ⚠️ **Hand-joined, not `Intl`.** Hungarian `Intl` writes *10. 25.*, with a space and a trailing
 * dot, which is too wide for a bar and not what was asked for. Both locales put the month first,
 * so the only difference is the separator. Built from the wire string's own parts, so no timezone
 * is involved (`hard-won.md`). Anything that is not a wire date renders as itself.
 */
export function formatMonthDay(wire: string, locale: Locale): string {
  const match = /^\d{4}-(\d{2})-(\d{2})$/u.exec(wire);
  if (match === null) return wire;
  const month = match[1] ?? '';
  const day = match[2] ?? '';
  return locale === 'hu' ? `${month}.${day}` : `${month}/${day}`;
}
